/**
 * @packageDocumentation
 * @module HackerAPI.Event.Activity
 */
import { __extends } from "tslib";
import Base from "../../base/base";
import HackerAPIFetch from "../../hackerapi-fetch/hackerapi-fetch";
import { parseDate } from "../../utils/utils";
/**
 * A container for data related to an event activity
 * @class
 * @extends { HackerAPI.Base }
 */
var Activity = /** @class */ (function (_super) {
    __extends(Activity, _super);
    /**
     * Creates a new Activity instance.
     * @constructor
     * @param activity
     */
    function Activity(_a) {
        var _b = _a === void 0 ? {} : _a, id = _b.id, name = _b.name, event_id = _b.event_id, eventId = _b.eventId, location = _b.location, category = _b.category, restrictions = _b.restrictions, start_time = _b.start_time, startTime = _b.startTime, end_time = _b.end_time, endTime = _b.endTime;
        var _this = _super.call(this) || this;
        /**
         * The ID of the activity
         * @type { number }
         */
        _this.id = id;
        /**
         * The name of the activity
         * @type { string }
         */
        _this.name = name;
        /**
         * The ID of the event that this activity is for
         * @type { number }
         */
        _this.eventId = event_id || eventId;
        /**
         * Where the activity is taking place
         * @type { string }
         */
        _this.location = location;
        /**
         * The category this event falls under
         * @type { string }
         */
        _this.category = category;
        /**
         * The restrictions applied to this activity
         * @type { any }
         * @example
         * // In hackerapi this is a JSONB column so this value could be whatever the fuck it wants to be
         * // but an example response has this
         * {
             *   "hacker": {
             *     "max_count": 2,
             *	   "min_delay": 10
             *	  },
             *	  "sponsor": {
             *		  "max_count": 2
             *	}
            }
         */
        _this.restrictions = restrictions;
        /**
         * The start time of the event
         * @type { Date }
         */
        _this.startTime = parseDate(start_time || startTime);
        /**
         * The end time of the event
         * @type { Date }
         */
        _this.endTime = parseDate(end_time || endTime);
        return _this;
    }
    /**
     * Gets the list of activities for an event
     * @param event
     * @param event.slug
     * @param [token]
     * @param [token.token]
     * @returns
     */
    Activity.fetchAll = function (_a, token) {
        var slug = _a.slug;
        return HackerAPIFetch({
            path: "/v2/events/" + slug + "/activities",
            method: "GET",
            token: token
        }).then(function (data) {
            return data.map(function (datum) { return new Activity(datum); });
        });
    };
    /**
     * Gets a specific activity for an event
     * @param event
     * @param event.slug
     * @param activity
     * @param activity.id
     * @param [token]
     * @param [token.token]
     * @returns
     */
    Activity.fetch = function (_a, _b, token) {
        var slug = _a.slug;
        var id = _b.id;
        return HackerAPIFetch({
            path: "/v2/events/" + slug + "/activities/" + id,
            method: "GET",
            token: token
        }).then(function (data) { return new Activity(data); });
    };
    /**
     * Creates an activity on hackerapi
     * @param event
     * @param event.slug
     * @param activity
     * @param [token]
     * @param [token.tokens]
     * @returns
     */
    Activity.create = function (_a, activity, token) {
        var slug = _a.slug;
        return HackerAPIFetch({
            path: "/v2/events/" + slug + "/activities",
            method: "POST",
            token: token,
            body: activity.toHackerAPIFormat()
        }).then(function (data) { return new Activity(data); });
    };
    /**
     * Updates an activity on hackerapi
     * @param event
     * @param event.slug
     * @param activity
     * @param [token]
     * @param [token.tokens]
     * @returns
     */
    Activity.update = function (_a, activity, token) {
        var slug = _a.slug;
        return HackerAPIFetch({
            path: "/v2/events/" + slug + "/activities/" + activity.id,
            method: "PUT",
            token: token,
            body: activity.toHackerAPIFormat()
        }).then(function (data) { return new Activity(data); });
    };
    /**
     * Deletes a specific activity for an event
     * @param event
     * @param event.slug
     * @param activity
     * @param activity.id
     * @param [token]
     * @param [token.token]
     * @returns
     */
    Activity.delete = function (_a, _b, token) {
        var slug = _a.slug;
        var id = _b.id;
        return HackerAPIFetch({
            path: "/v2/events/" + slug + "/activities/" + id,
            method: "DELETE",
            token: token
        });
    };
    return Activity;
}(Base));
export default Activity;
//# sourceMappingURL=activity.js.map